import { Capacitor } from '@capacitor/core';

/**
 * Get the correct API base URL depending on the platform
 * Native mobile apps: Always use Cloud Run backend
 * Web Production: Use Cloud Run backend
 * Web Development: Use localhost
 */
export const getApiBaseUrl = () => {
  // Always use production API on native mobile apps
  // (Capacitor serves from localhost, which would incorrectly trigger dev mode)
  if (Capacitor.isNativePlatform()) {
    console.log('[API Config] Native platform detected, using production API');
    return 'https://dijitto-api-1047315807678.us-central1.run.app';
  }

  // Web: Use localhost for dev, Cloud Run for production
  const isLocalDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiUrl = isLocalDev
    ? 'http://localhost:3002'
    : 'https://dijitto-api-1047315807678.us-central1.run.app';
  console.log('[API Config] Using API URL:', apiUrl);
  return apiUrl;
};

export default getApiBaseUrl;
